import { identifyAnonymous, identify } from './chunk-5FA6E5V7.js';
import { init } from './chunk-LRVXNGZT.js';
import { onSessionUrlInitialized } from './chunk-3LIABNX3.js';

// src/registerLogRocketInstrumentation.ts
function registerAnonymousLogRocketInstrumentation(options) {
  init(options.appId, options.options || {});
  identifyAnonymous(options.trackingIdentifier);
  if (options.onSessionUrlInitialized) {
    onSessionUrlInitialized(options.onSessionUrlInitialized);
  }
}
function registerLogRocketInstrumentation(options) {
  init(options.appId, options.options || {});
  identify(options.trackingIdentifier, options.identifyOptions);
  if (options.onSessionUrlInitialized) {
    onSessionUrlInitialized(options.onSessionUrlInitialized);
  }
}

export { registerAnonymousLogRocketInstrumentation, registerLogRocketInstrumentation };
